// extracted by mini-css-extract-plugin
export var bg = "CustomPageHeader-module--bg--kndYP";
export var bxTextTruncateEnd = "CustomPageHeader-module--bx--text-truncate--end--CH-kD";
export var bxTextTruncateFront = "CustomPageHeader-module--bx--text-truncate--front--OUvMz";
export var darkMode = "CustomPageHeader-module--dark-mode--7auRn";
export var desc = "CustomPageHeader-module--desc--lyIRV";
export var dotsElement = "CustomPageHeader-module--dots-element--TqFIt";
export var flex = "CustomPageHeader-module--flex--yn8gS";
export var imageContainer = "CustomPageHeader-module--image-container--4g22i";
export var introHeader = "CustomPageHeader-module--intro-header--oloJN";
export var label = "CustomPageHeader-module--label--Z8mz+";
export var left = "CustomPageHeader-module--left--5Lnzj";
export var maxWidthFull = "CustomPageHeader-module--max-width-full--353av";
export var pageHeader = "CustomPageHeader-module--page-header--BP+13";
export var text = "CustomPageHeader-module--text--xqNu9";
export var withTabs = "CustomPageHeader-module--with-tabs--Oq-+t";